class NodeSourceGeometry {
    constructor(NodeWidth, NodeHeight) {
        this.NodeWidth = NodeWidth;
        this.NodeHeight = NodeHeight;
    }
}
export default NodeSourceGeometry;
